// services/watchlist.service.js
// Thin API wrappers — each takes authFetch as first parameter

export const getWatchlist = async (authFetch) => {
  const res = await authFetch("/watchlist");
  if (!res.ok) throw new Error("Failed to load watchlist");
  return res.json();
};

export const addToWatchlist = async (
  authFetch,
  { ticker, alert_type, threshold_pct },
) => {
  const res = await authFetch("/watchlist", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ticker, alert_type, threshold_pct }),
  });
  if (res.status === 409)
    throw new Error("Already watching this ticker with this alert type");
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Failed to add to watchlist");
  }
  return res.json();
};

export const removeFromWatchlist = async (authFetch, ticker, alert_type) => {
  const params = alert_type ? `?alert_type=${alert_type}` : "";
  const res = await authFetch(`/watchlist/${ticker}${params}`, {
    method: "DELETE",
  });
  if (!res.ok) throw new Error("Failed to remove from watchlist");
  return res.json();
};

export const getMe = async (authFetch) => {
  const res = await authFetch("/users/me");
  if (!res.ok) throw new Error("Failed to load user");
  return res.json();
};

export const togglePipelineNotifications = async (authFetch, enabled) => {
  const res = await authFetch("/users/me/pipeline-notifications", {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ enabled }),
  });
  if (!res.ok) throw new Error("Failed to update notification preference");
  return res.json();
};
